import { useTranslation } from 'react-i18next';

import { ReactComponent as Roles } from 'assets/icons/Roles.svg';
import NoResultsPlaceholder from 'components/NoResultsPlaceholder/NoResultsPlaceholder';
import useActorWorkspaceRole from 'hooks/useActorWorkspaceRole/useActorWorkspaceRole';
import SettingsCard from 'modules/SettingsModal/SettingsCard/SettingsCard';

import RolePermissionsReadOnlyPanel from './RolePermissionsReadOnlyPanel';

/** AC-101 / AC-078: actor without adjustRoles sees only their own role inline (no list, no modal). */
const ActorOwnRoleSettingsView = () => {
  const { t } = useTranslation();
  const actorRole = useActorWorkspaceRole();

  if (!actorRole) {
    return <NoResultsPlaceholder className="bg-white" title={t('workspaces.no_role_assigned')} icon={Roles} />;
  }

  return (
    <SettingsCard>
      <SettingsCard.Content className="flex flex-col gap-4 px-4 py-4">
        <RolePermissionsReadOnlyPanel role={actorRole} showOnlyEnabledPermissions />
      </SettingsCard.Content>
    </SettingsCard>
  );
};

export default ActorOwnRoleSettingsView;
